import React from "react";
import { Route, Switch } from "react-router-dom";
import ModalDialog from "./elements/modal/ModalDialog";
import Footer from "./Footer";
import Header from "./header/Header";
import login from "./login";
import Logout from "./Logout";
import NotFound from "./errorPages/NotFound";
import AccessDenied from "./errorPages/AccessDenied";

const AuthLayout = () => {
  return (
    <>
      <Header />
      <Switch>
        <Route path="/" exact component={login} />
        <Route path="/login" exact component={login} />
        <Route path="/logout" exact component={Logout} />
        <Route path="/password-reset/:code?" exact component={login} />
        <Route path="/sso" exact component={login} />
        <Route path="/access-denied" exact component={AccessDenied}/>
        <Route path="*" component={NotFound}/>
      </Switch>
      <Footer />
      <ModalDialog />
    </>
  );
};

export default AuthLayout;
